import { useEffect, useRef } from "react";

type Callback = () => void;
const initCallback: Callback = function () {};

function useInterval(callback: Callback, delay: any) {
    const savedCallback = useRef<Callback>(initCallback);

    // Remember the latest callback.
    useEffect(() => {
        savedCallback.current = callback;
    }, [callback]);

    // Set up the interval.
    useEffect(() => {
        function tick() {
            savedCallback.current();
        }
        if (delay !== null) {
            let id = setInterval(tick, delay);
            return () => clearInterval(id);
        }
    }, [delay]);
}

export default useInterval;
